import { useCallback, memo } from "react";
import { Fade, Stack } from "@mui/material";
import {
  MentionInput,
  MentionOption,
} from "../../input/MentionInput/MentionInput";
import { EXPORT_INCLUSION_TYPES } from "../types";

const MemoizedMentionInput = memo(
  ({
    selectedMentionIds,
    onMentionsSelect,
  }: {
    selectedMentionIds: number[];
    onMentionsSelect: (value: MentionOption[]) => void;
  }) => (
    <Fade in={true} timeout={300}>
      <Stack sx={{ mx: 4 }}>
        <MentionInput
          selectedMentionIds={selectedMentionIds}
          onMentionsSelect={onMentionsSelect}
        />
      </Stack>
    </Fade>
  )
);

MemoizedMentionInput.displayName = "MemoizedMentionInput";

export const useMentionFilterRenderer = (
  inclusion: EXPORT_INCLUSION_TYPES,
  selectedMentionIds: number[],
  onMentionsSelect: (ids: number[]) => void
) => {
  const handleMentionsSelect = useCallback(
    (value: MentionOption[]) => {
      onMentionsSelect(value.map((option) => Number(option.value)));
    },
    [onMentionsSelect]
  );

  return useCallback(
    (optionValue: string) => {
      if (
        optionValue === EXPORT_INCLUSION_TYPES.SELECTED &&
        inclusion === EXPORT_INCLUSION_TYPES.SELECTED
      ) {
        return (
          <MemoizedMentionInput
            selectedMentionIds={selectedMentionIds}
            onMentionsSelect={handleMentionsSelect}
          />
        );
      }
      return null;
    },
    [inclusion, selectedMentionIds, handleMentionsSelect]
  );
};
